import { Splash } from '@toilet-paper-games/ui';
import { HosterGamePlayer } from '../components/HosterGamePlayer';
import { useHosterAppModel } from '../models/HosterAppModel';

export function GamePlayerPage() {
  const appStore = useHosterAppModel();

  if (!appStore.selectedGame) return <div>no selected game</div>;

  return (
    <Splash>
      <HosterGamePlayer lobbyGame={false} game={appStore.selectedGame} />
    </Splash>
  );
}
